import type { ComponentType } from 'react';

import type {
  RewardPoolDistributionPolicy} from '@api/types/rewardPools';
import {
  REWARD_POOL_DISTRIBUTION_POLICY
} from '@api/types/rewardPools';

import { ProrataSwapActionsList } from './swap/ProrataSwapActionsList';
import { RaffleSwapActionsList } from './swap/RaffleSwapActionsList';
import type { ActionsListProps } from './types';

const DistributionPolicyToActionsListMap: Record<
  RewardPoolDistributionPolicy,
  ComponentType<ActionsListProps> | null
> = {
  [REWARD_POOL_DISTRIBUTION_POLICY.PRO_RATA_SWAP]: ProrataSwapActionsList,
  [REWARD_POOL_DISTRIBUTION_POLICY.PRO_RATA_KARMA]: null,
  [REWARD_POOL_DISTRIBUTION_POLICY.FCFS]: null,
  [REWARD_POOL_DISTRIBUTION_POLICY.FCFS_V2]: null,
  [REWARD_POOL_DISTRIBUTION_POLICY.RAFFLE]: null,
  [REWARD_POOL_DISTRIBUTION_POLICY.RAFFLE_V2]: null,
  [REWARD_POOL_DISTRIBUTION_POLICY.RAFFLE_SWAP]: RaffleSwapActionsList,
};

export const ActionsList = ({ rewardPool, locked }: ActionsListProps) => {
  const Component = DistributionPolicyToActionsListMap[rewardPool.distribution_policy];

  if (!Component) {
    return Component;
  }

  return <Component rewardPool={rewardPool} locked={locked} />;
};
